export default __webpack_public_path__ + "static/media/credit-cards.73a6e826.svg";